// components
import PermissionEditorAbstract from '../PermissionEditorAbstract';

const allControllers = [
    'merchants',
    'roles-permissions',
    'partner-has-coins',
    'files',
    'partners',
    'coins',
    'users',
    'wallets',
    'transactions',
    'payment-gateways',
    'currencies',
    'external-transactions',
    'currency-exchange-pairs',
    'roles-actions-permissions',
    'merchant-locations',
    'merchant-location-files',
    'merchant-files',
    'merchant-employees',
    'partner-accounts',
    'fee-transactions',
    'coin-currency-pairs',
    'currency-exchange-rates',
    'merchant-categories',
    'system-messages'
];

export default class PermissionsEditor extends PermissionEditorAbstract {
    constructor(props) {
        super(props);

        this.Name = 'rolePermissions';
        this.Server = this.props.context.getState().server.rolePermissions;

        this.Head = [
            {
                id: 'controller',
                label: 'controller',
                type: 'controller',
                alignRight: false,
                cell: 'Text',
                items: allControllers,
                filterCell: 'Items',
                filterBy: 'controller',
                needTranslate: true,
                needStyle: true,
                isSingle: true,
                displayGrid: true
            },
            // {
            //     id: 'roleId',
            //     label: 'role',
            //     object: 'role',
            //     display: 'name',
            //     filterCell: 'Context',
            //     filterBy: 'roles',
            //     needStyle: true,
            //     isSingle: true,
            //     alignRight: false,
            //     cell: 'Select',
            //     needTranslate: true,
            //     displayGrid: true
            // },
            {
                id: 'read',
                label: 'read',
                alignRight: false,
                cell: 'EditorSelect',
                items: ["allow_all", "allow_own", "deny"],
                displayGrid: true
            },
            {
                id: 'update',
                label: 'update',
                alignRight: false,
                cell: 'EditorSelect',
                items: ["allow_all", "allow_own", "deny"],
                displayGrid: true
            },
            {
                id: 'create',
                label: 'create',
                alignRight: false,
                cell: 'EditorSelect',
                items: ["allow_all", "allow_own", "deny"],
                displayGrid: true
            },
            {
                id: 'delete',
                label: 'delete',
                alignRight: false,
                cell: 'EditorSelect',
                items: ["allow_all", "allow_own", "deny"],
                displayGrid: true
            }
        ];
    }
    saveCurrentData = () => {
        const defaultFilter = {
            field: 'role.id',
            op: '@',
            value: [1]
        };
        this.setState(
            (prevState) => ({
                currentValues: this.List.reduce((acc, cur) => {
                    acc[cur.id] = {
                        read: cur.read,
                        update: cur.update,
                        create: cur.create,
                        delete: cur.delete
                    };
                    return acc;
                }, {}),
                defaultFilter: [defaultFilter]
            })
        );
    };
}
